module.exports = __webpack_public_path__ + "img/google-play-badge.1b557d39.png";